import React, { useRef } from "react";
import styles from "./ImageUploadInput.module.scss";

interface ImageUploadInputProps {
  label?: string;
  value?: string | null;
  onChange: (file: File | null) => void;
}

const ImageUploadInput: React.FC<ImageUploadInputProps> = ({
  label = "Şəkil yüklə",
  value,
  onChange,
}) => {
  const fileRef = useRef<HTMLInputElement | null>(null);
  console.log(value);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    onChange(file);
  };

  return (
    <div className={styles.uploadWrapper}>
      {label && <label className={styles.label}>{label}</label>}

      {!value ? (
        <div
          className={styles.uploadBox}
          onClick={() => fileRef.current?.click()}
        >
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            hidden
          />

          <div className={styles.icon}>📁</div>
          <p className={styles.text}>Şəkil seç / Yüklə</p>
        </div>
      ) : (
        <div className={styles.previewBox}>
          <img src={value} alt="preview" className={styles.image} />

          <button className={styles.removeBtn} onClick={() => onChange(null)}>
            Sil
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageUploadInput;
